// import Loading from "@/components/common/Loading";
// import switchStyles from "../styles/desktopMobileSwitch.module.css";
// import dynamic from "next/dynamic";
// import Head from "next/head";



// const AllInOneDesktop = dynamic(
//    () => import("../components/allInOne/AllInOneDesktop"), {
//    loading: () => <Loading />,
//    ssr: false
// }
// );
// const AllInOneMobile = dynamic(
//    () => import("../components/allInOne/AllInOneMobile"), {
//    loading: () => <Loading />,
//    ssr: false
// }
// );


// // const AllInOneDesktop = dynamic(() => import("../components/allInOne/AllInOneDesktop"), {
// //    loading: () => <Loading />,
// // });

// // const AllInOneMobile = dynamic(
// //    () => import("../components/allInOne/AllInOneMobile"),
// //    {loading: () => <Loading />, }
// // );

// const AllInOnePos = ({ mobileView }) => {
//    return (
//       <>
//          <Head>
//             <title>All-in-One POS Billing Software for Small & Large Enterprises</title>
//             <meta
//                name="description"
//                content="QueueBuster POS Billing Software for retail shop, employee management, vendor management. online & offline billing for small & large businesses."
//             />
//             <link rel="canonical" href="https://queuebuster.co/all-in-one-pos-billing-software" />
//             <link rel="alternate" href="https://queuebuster.co/all-in-one-pos-billing-software" hrefLang="en-us" />
//             <meta
//                property="og:title"
//                content="Make your business Automated with QueueBuster POS!"
//             />
//             <meta
//                property="og:description"
//                content="Modify your retail shop with QueueBuster's comprehensive All-in-One POS Billing Software. Simplify operations, manage inventory, and enhance customer experiences. Get free demo today!"
//             />
//             <meta property="og:url" content="https://queuebuster.co/all-in-one-pos-billing-software" />
//             <meta
//                property="og:image"
//                content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/ALL-IN-ONE_OG.png"
//             />
//          </Head>
//          {
//             mobileView ? <AllInOneMobile /> : <AllInOneDesktop />
//          }
//       </>
//    );
// };

// export default AllInOnePos;



import Loading from "@/components/common/Loading";
import switchStyles from "../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";

const AllInOneDesktop = dynamic(
   () => import("../components/allInOne/AllInOneDesktop"),
   {
      loading: () => <Loading />,
      ssr: false
   }
);

const AllInOneMobile = dynamic(
   () => import("../components/allInOne/AllInOneMobile"),
   {
      loading: () => <Loading />,
      ssr: false
   }
);

const AllInOnePos = ({ mobileView }) => {
   return (
      <>
         <Head>
            <title>All-in-One POS Billing Software for Small & Large Enterprises</title>
            <meta
               name="description"
               content="QueueBuster POS Billing Software for retail shop, employee management, vendor management. online & offline billing for small & large businesses."
            />
            <link rel="canonical" href="https://queuebuster.co/all-in-one-pos-billing-software" />
            <link rel="alternate" href="https://queuebuster.co/all-in-one-pos-billing-software" hrefLang="en-us" />
            <meta
               property="og:title"
               content="Make your business Automated with QueueBuster POS!"
            />
            <meta
               property="og:description"
               content="Modify your retail shop with QueueBuster's comprehensive All-in-One POS Billing Software. Simplify operations, manage inventory, and enhance customer experiences. Get free demo today!"
            />
            <meta property="og:url" content="https://queuebuster.co/all-in-one-pos-billing-software" />
            <meta
               property="og:image"
               content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/ALL-IN-ONE_OG.jpg"
            />
         </Head>
         <h1></h1>
         {mobileView ? <AllInOneMobile /> : <AllInOneDesktop />}
      </>
   );
};

export default AllInOnePos;
